export var LINE_BREAK_CHARACTER = "\uFEFF";
export var WHITESPACE_CHARACTER = ' ';